import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { baseURl } from "../../config";
import "./GalleryDetail.css";
import { useParams } from "react-router-dom";
import { IoIosArrowForward , IoIosArrowBack } from "react-icons/io";


const GalleryDetail = () => {
  const { gallery } = useSelector((state) => state.data);
  const [index, setIndex] = useState(0);
  const [images, setImages] = useState([]);
  const { typeSlug } = useParams();
  
  useEffect(() => {
    const filteredGallery = gallery.filter((galleryItem) => galleryItem.typeSlug === typeSlug);
  
    if (filteredGallery.length < 7) {
      let i = 0;
      while (filteredGallery.length < 7) {
        filteredGallery.push(filteredGallery[i % filteredGallery.length]);
        i++;
      }
      setImages(filteredGallery);
    } else {
      setImages(filteredGallery);
    }
  }, [gallery, typeSlug]); 

  useEffect(() => {
    const interval = setInterval(() => {
     setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  const nextImage = () => {
    setIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="gallery-container2">
      <button className="nav-button left" onClick={prevImage}>
      <IoIosArrowBack />
      </button>

      <div className="image-stack">
        {images.map((img, i) => {
          const position = (i - index + images.length) % images.length;
          let transformStyle = "";
          let zIndex = 1;
          let opacity = 1;

          if (position === 0) {
            transformStyle = "scale(1)";
            zIndex = 5;
          } else if (position >= 1 && position <= 3) {
            transformStyle = `translateX(${position * 150}px) scale(${1 - position * 0.1})`; 
            zIndex = 4 - position;
          } else if (position >= images.length - 3) {
            let leftPosition = images.length - position;
            transformStyle = `translateX(-${leftPosition * 150}px) scale(${1 - leftPosition * 0.1})`; 
            zIndex = 4 - leftPosition;
          } else {
            opacity = 0;
          }

          return (
            <div
              key={i}
              className={`image-card ${position === 0 ? "center" : position === 1 || 2 ? "right" : position === images.length - 1 ? "left" : ""}`}
              style={{
                transform: transformStyle,
                zIndex,
                opacity,
              }}
            >
              <a
                href={`${baseURl}/${img.galleryImage}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`${baseURl}/${img.galleryImage}`} alt={img.heading} />
              </a>
            </div>
          );
        })}
      </div>

      <button className="nav-button right" onClick={nextImage}>
      <IoIosArrowForward />
      </button>
    </div>
  );
};

export default GalleryDetail;